<app-loader-2 *ngIf="isLoading$ | async"></app-loader-2>

<div *ngIf="!(isLoading$ | async)">
  <ng-container *appHideForGuest>
    <app-message *ngIf="isAllowedToWritePost$ | async" [ctx]="messageCtx" class="theme-block message"></app-message>
  </ng-container>
  <app-posts [posts]="posts$ | async" [ctx]="postsCtx"></app-posts>
</div>
